import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AwsAuthErrorCodes, AwsAuthErrorMessage } from '@app/auth/models';
import { AuthError } from '@aws-amplify/auth';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class AwsErrorService {
    private translate = inject(TranslocoService);
    private snackBar = inject(MatSnackBar);

    handleAuthError(error: AuthError) {
        this.snackBar.open(this.getMessage(error), undefined, {
            duration: 5000,
            verticalPosition: 'bottom',
            panelClass: 'notification-snackbar',
        });
    }

    getMessage(error: unknown) {
        console.log(error);
        if (error instanceof AuthError) {
            const messageKey = AwsAuthErrorMessage[error.name as AwsAuthErrorCodes];
            return messageKey ? this.translate.translate(messageKey) : error.message;
        }
        if (error instanceof Error) {
            return error.message;
        }
        return this.translate.translate('ERROR');
    }
}
